import type { IMunicipality } from '../../../models/municipality.model';

export default class MunicipalityApiModel {
  public gid!: string;
  public name!: string;

  public static mapToBusinessModel(apiModel: MunicipalityApiModel): IMunicipality {
    return {
      gid: apiModel.gid,
      name: apiModel.name,
    };
  }

  public static mapToApiModel(businessModel: IMunicipality): MunicipalityApiModel {
    return {
      gid: businessModel.gid,
      name: businessModel.name,
    };
  }
}

